import React, { useState, useRef, useEffect, useContext } from 'react'
import cn from 'classnames'
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch , useSelector } from 'react-redux';
import { WithContext as ReactTags } from "react-tag-input";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Card from '../../../../../../components/Card'
import TextInput from '../../../../../../components/TextInput'
import TextArea from '../../../../../../components/TextArea'
import CommonDropdown from '../../../../../Builds/Economy/Store/EditStores/StoreInformation/CommonDropdown'
import Radio from '../../../../../../components/Radio';
import Tooltip from "../../../../../../components/Tooltip";
import styles from './stepSeriesInfo.module.sass'
import Control from '../Control';
import Schedule from '../Schedule'
import ControlRewards from '../ControlRewards';
import ContentTable from '../../../../../../components/BuildComponents/EconomyComponent/BundlesComponent/ContentTableLayout'
import StepSeriesTableLayout from '../../../../../../components/EngageComponents/AchievementComponent/StepSeriesComponent/TableComponent'
import Dropdown from '../../../../../../components/Dropdown';
import { getAllCurrencyAction } from '../../../../../../redux/action/builds/economy/currency/currencyAction';
import { getAllItemAction } from '../../../../../../redux/action/builds/economy/items/itemAction';
import { getAllBundlesAction } from '../../../../../../redux/action/builds/economy/bundles/bundleAction';
import { getAllProgressionMarkerAction } from '../../../../../../redux/action/builds/progression/progressionMarker/progressionMarkerAction';
import TagInputWithDropdown from "../../../../../../components/TagInputWithDropdown";
import Mission from '../../../../../../media/images/placeholders/Mission.png'
import {ReactComponent as AddButtonIcon} from '../../../../../../media/images/icons/add_button.svg'
import {ReactComponent as AddMetaIcon} from '../../../../../../media/images/icons/add_meta.svg'
import {ReactComponent as AddRuleIcon} from '../../../../../../media/images/icons/Rule_Add_SVG.svg'
import {ReactComponent as RemoveIcon} from '../../../../../../media/images/icons/remove.svg'
import { getAllProgressionSystemAction } from '../../../../../../redux/action/builds/progression/progressionSystem/progressionSystemAction';
import { createStepSeriesAction, editStepSeriesAction, getAllStepSeriesAction } from '../../../../../../redux/action/engage/Achievement/StepSeries/StepSeriesAction';
import { BASE_URL, GET_PROGRESSION_SYSTEM, GET_STEP_SERIES } from '../../../../../../resources/APIEndpoints';
import Toast from '../../../../../../components/Toast';
import FileUploadSidebar from '../../../../../../components/FileUploadSidebar';
import { getAllMediaAction } from '../../../../../../redux/action/AppSettings/Media/mediaAction';
import customAxios from '../../../../../../utils/interceptor';
import TooltipTitle from '../../../../../../Tooltip/TooltipTitle';
import Tooltips from '../../../../../../components/Tooltip';
import JSONMetaDataValueInput from '../../../../../../components/MetaInput';
import ProgressionLevelMultiSelect from '../../../../../../components/Dropdown/ProgressionLevelTypeableDropdown';
import Checkbox from '../../../../../../components/Checkbox';
import Switch from '../../../../../../components/Switch';
import app,{increaseUnreadCountForAllUsers} from "../../../../../../firebase.js"
import { getFirestore, collection, addDoc } from "firebase/firestore";
import GlobalStateContext from '../../../../../../components/Context/GlobalStates/GlobalStateContext.js';
// Static Data


const StepSeriesInfo = ({className, onClose, setIsChanged}) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {appid} = useParams()
    const {id} = useParams()
    const ref = useRef()

    // StepSeriesInfo Informations
    const globalStates = useContext(GlobalStateContext)
    const placeholder = Mission
    const [{alt, src}, setLogo] = useState({src: placeholder , alt: 'Upload an Image'}); 
    const [iconUrl, setIconUrl] = useState()
    const [name, setName] = useState()
    const [stepSeriesId, setStepSeriesId] = useState()
    const [description, setDescription] = useState()

    const [type, setType] = useState('')
    const [typeId, setTypeId] = useState('')
    const typesOption = [{id : 1, name : 'static'},{id : 2, name : 'daily'},{id : 3, name : 'weekly'}]
    const [claim, setClaim] = useState(false)
    const [missionReward, setMissionReward] = useState(true)


    // Access and Eligibility
    const [PSOptions, setPSOptions] = useState([])
    const [lockPSErr, setLockPSErr] = useState(false)
    const [lockBy, setLockBy] = useState(false)
    const [PS, setPS] = useState([])
    const [called, setCalled] = useState(false)

    const uploadLogo = async(e) =>{
        if(e.target.files[0]) {
            setLogo({src: URL.createObjectURL(e.target.files[0]), alt: e.target.files[0].name});    
        } 
        // Converting Image to base64 and then converting to binary to upload
        var file = e.target.files[0];   
        const file_binary = await convertbase64(file)
        const res = await axios.get(`${BASE_URL}/admin/upload-url?contentType=${file.type}`)
        setIconUrl(res.data.getUrl);
        var config = {
            headers : {'Content-Type' : `${file.type}`},
            method: 'put',
            url: res.data.postUrl,
            data :convertDataURIToBinary(file_binary),
        }
        axios(config)
        .then(function (response) {
            toast.success(<Toast type='Success' messages='Logo Uploaded Successfully'/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
        })
        .catch(function (error) {
            //toast.error(<Toast type='Error' messages='Logo not uploaded. Please try again!'/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
        });
    }

    // To Convert Base64 to Binary
    function convertDataURIToBinary(dataURI) {
        var BASE64_MARKER = ';base64,';
        var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
        var base64 = dataURI.substring(base64Index);
        var raw = window.atob(base64);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
              
        for(var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }
        
    // To Convert file into base64 format
    const convertbase64 = (file) => {
        return new Promise((resolve, err)=>{
        const fileReader = new FileReader();
        fileReader.onload = (eve) =>{
            resolve(fileReader.result)
        }
        fileReader.readAsDataURL(file)
        })
    }

    const Cancel = () => {
        setIconUrl(null)
        setLogo({src: placeholder , alt: 'Upload an Image'})
        ref.current.value = ''
    }

    const onChangeName = (e) => {
        if(e.target.value == ''){
            setName('')
        }else{
            errors.nameError = ''
            setName(e.target.value)
        }
    }

    const onChangeId = (e) => {
        if(e.target.value == ''){
            setStepSeriesId('')
        }else{
            errors.idError = ''
            setStepSeriesId(e.target.value)
        }
    }

    const onChangeDescription = (e) => {
        setDescription(e.target.value)
    }

    // Access and Eligibility

    useEffect(() => {
        getPS()
    }, [])

    // let progressionSystem = useSelector((state) => {
    //     return state.progressionSystem.progressionSystem
    // })

    // useEffect(() => {
    //     configPS()
    // }, [progressionSystem])

    // const configPS = () => {
    //     setPSOptions(progressionSystem)
    // }

    const getPS = async() => {
        let items = {
            projectId : appid
        }
        const token = localStorage.getItem('token')
        const headers = {headers : {"Authorization" : `Bearer ${token}`, "Api-Key" : (localStorage.getItem('environment') == 'Production' ? JSON.parse(localStorage.getItem('apiKeys')).productionAPIKey : localStorage.getItem('environment') == 'Staging' ? JSON.parse(localStorage.getItem('apiKeys')).stagingAPIKey : JSON.parse(localStorage.getItem('apiKeys')).devAPIKey)}}
        let res = await customAxios.post(BASE_URL + GET_PROGRESSION_SYSTEM, items, headers)
        let progressionSystem = res.data.data.levelDetails
        progressionSystem && progressionSystem.forEach((e,i) => {
            return setPSOptions(prevState => [...prevState, {name : e.name, id : e.id, levelSystemLevelMapping:e.levelSystemLevelMapping}])
        })
    }

    const onChangeLevel = (value, index) => {
        let unlockLevelSystem = [...PS]
        unlockLevelSystem[index].lockedLevel = parseInt(value)
        setPS(unlockLevelSystem)
    }

    // Custom Data

    const [tags, setTags] = useState([]);

    const KeyCodes = { comma: 188, enter: 13 };
      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const handleDelete = (i) => {
      setTags(tags.filter((tag, index) => index !== i));
    };
  
    const handleAddition = (tag) => {
        if(tags.length < 10){
            setTags([...tags, tag]); 
        }else{
            toast.warning(<Toast type='Warning' messages='Only 10 tags are allowed'/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
        }
    };
    
    const handleDrag = (tag, currPos, newPos) => {
      const newTags = [...tags].slice();
      newTags.splice(currPos, 1);
      newTags.splice(newPos, 0, tag);
  
      setTags(newTags);
    };
  
    const handleTagClick = (index, event) => {
        event.stopPropagation();
    };
  
    const onClearAll = () => {
      setTags([]);
    };
  
    const onTagUpdate = (i, newTag) => {
      const updatedTags = tags.slice();
      updatedTags.splice(i, 1, newTag);
      setTags(updatedTags);
    };

    const onTagInput = () => {
        if(document.getElementById('tagsInput')){
            document.getElementById('tagsInput').focus()
        }
    }

    const [metaData, setMetaData] = useState([{key : '' , value : null}])

    const addMetaData = () => {
        const metaDataField = []
        metaDataField.push(...metaData, {key : '' , value : null})
        setMetaData(metaDataField)
    }

    const removeMetaData = (index) => {
        let removeField = metaData
        let metaFields = removeField.filter((e,i,c)=>{
            return i != index
        })
        setMetaData(metaFields)
    }

    const onChangeKey = (e, index) => {
        let keys = [...metaData]
        keys[index].key = e.target.value
        setMetaData(keys)
    }

    const onChangeValue = (e, index) => {
        let values = [...metaData]
        values[index].value = e.target.value
        setMetaData(values)
    }

    const [cyclePerMission, setCyclePerMission] = useState(null)

    const onCycleperMission = (e) => {
        if(e.target.value == ''){
            setCyclePerMission(null)
        }else{
            setCyclePerMission(parseInt(e.target.value))
        }
    }

    const [errors, setErrors] = useState({nameError : '', idError : ''})

    const validation = (data) => {
        const error = {}
        let isValid = true

        if (data.name == '') {
          error.nameError = 'Display Name is required';
          isValid = false;
          const element = document.getElementById('missionName');
          const offset = 140;
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = element.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;
          window.scrollTo({top: offsetPosition, behavior: 'smooth'});
        }
      
        if (data.taskGroupId == '') {
          error.idError = 'Mission ID is required';
          isValid = false;
          if(data.name != ''){
            const element = document.getElementById('missionId');
            const offset = 140;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;
            window.scrollTo({top: offsetPosition, behavior: 'smooth'});
          }
        }

        setErrors(error);

        if(isValid){
            return true
        }
    }

    const compareRewardsUnlockDetail = (data, compareArray) => {
        const result = data && data.filter(obj1 => {
            const matchingObj = compareArray && compareArray.find(obj2 => obj2.levelSystemId === obj1.levelSystemId); 
            if (!matchingObj) {
                // Include the object if it doesn't exist in array2 and archive is false
                return !obj1.archive;
            }
            const isLevelChanged = obj1.level !== matchingObj.levelNo;
            const isArchiveChanged = obj1.archive !== matchingObj.archive;
            if (isLevelChanged || isArchiveChanged) {
                // Add updatedLevel only if level is changed
                obj1.updatedLevel = isLevelChanged ? obj1.level : null;
                obj1.level = matchingObj.levelNo;
                return true;
            }
            return false;
        })
        return result
    }

    const compareLinkRewards = (linkedRewardDetails, array) => {
        const result = array && array.filter(item => {
          // Find if the item exists in linkRewards by id
          const existingItem = linkedRewardDetails.find(lr => lr.id === item.id);
          // Check for new entries, changed quantity, or archive status
          if (!existingItem) {
            if (item.archive === undefined) {
                item.archive = false;
            }        
            return item.archive === false; // New entry
          }
          return (
            item.quantity !== existingItem.quantity ||  item.archive === true // Archive is true
          );
        }).map(({ id, ...rest }) => rest)
      
        return result;
    }

    const compareTaskLinkRewards = (oldArray, newArray) => {
        return newArray.map(newItem => {
            // Find the corresponding item in the old array
            const oldItem = oldArray.find(item => item.id === newItem.id);
        
            if (!oldItem) return { ...newItem }; // If old item doesn't exist, return newItem with empty linkRewardDetails
        
            // Compare the linkRewardDetails for differences in quantity, archive, or new entries
            const updatedLinkRewards = newItem.linkedRewardDetails.filter(newReward => {
                const oldReward = oldItem.linkedRewardDetails.find(reward => reward.id === newReward.id);
                if (newReward.archive === undefined) {
                    newReward.archive = false;
                }
                // Check if quantity has changed, archive is true, or it's a new entry
                return (
                    !oldReward || // New entry
                    newReward.quantity !== oldReward.quantity || // Quantity changed
                    newReward.archive === true // Archive is true
                );
            }).map(({ id, ...rest }) => rest)
        
            // Return the original item with updated linkRewardDetails, or empty if no changes
            const { linkedRewardDetails, ...restOfNewItem } = newItem;
            return updatedLinkRewards.length > 0 ? { ...restOfNewItem, linkedRewardDetails: updatedLinkRewards } : { ...restOfNewItem }
        })
    }
    const db = getFirestore(app);

    const submit = async(visibleModal, setVisibleModal) => {
        let unlockPS = []
        PS && PS.map((e,i) =>{
            unlockPS.push({archive: (e.archive ? e.archive : false), unlockItemId : null, levelSystemId : e.id, level : e.lockedLevel})
        })

        if (lockBy === false) {
            unlockPS && unlockPS.map((e)=>(e.archive = true))
        }
        
        const metaDataList = [...metaData];
        const finalMetaData = {};
        for(var i = 0; i < metaDataList.length ; i++){
            finalMetaData[metaDataList[i].key] = metaDataList[i].value;
        }

        let eventTags = []
        tags && tags.forEach((e)=>{
            eventTags.push(e.text)
        })

        let taskDetails = JSON.parse(sessionStorage.getItem('step-series'))
        taskDetails = taskDetails && taskDetails.map((e,i) => ({...e, tags: e.tagsMapping.map(item => item.tag.name)})).map(({tagsMapping, ...rest}) => ({...rest}))
        let filteredData = taskDetails&& taskDetails.map((item) => {
            const {displayId, ...rest} = item
            item.type = type
            const rewardDetails = item.rewardDetails && item.rewardDetails.map(({iconUrl, name, type, displayId, id, ...content}) => content);
            return {...rest, rewardDetails };
        });

        if(missionOrder == true){
            filteredData = filteredData && filteredData.map((e,i) => ({...e, sortingOrder : i+1}))
        }

        let rewardDetails = JSON.parse(sessionStorage.getItem('contents'))
        const addedContent = rewardDetails && rewardDetails.map(({iconUrl, name, type, displayId, id, ...content}) => content)
        const missionContent = addedContent.filter(item => !item.archive)

        const rewards = JSON.parse(sessionStorage.getItem('link-rewards'))
        const addedRewards = rewards && rewards.map(({iconUrl, name, type, displayId, ...content}) => content)
        const updatedRewards = await compareLinkRewards(checkRewards, addedRewards)

        let lockByPSLevel = await compareRewardsUnlockDetail(unlockPS, checkObject.levelDetails)

        let updatedTaskDetails = await compareTaskLinkRewards(checkTask, filteredData)

        let mission = {
            typeId: 1,
            // type : type,
            rewardClaim : (missionReward == false ? 'automatic' : 'on-claim'),
            rewardDetails : missionContent,
            ...(updatedRewards?.length > 0 && {linkedRewardDetails: updatedRewards}),
            noOfMissionsPerCycle : (missionCycle ? filteredData?.length : cyclePerMission),
            shouldIncludeAllTasks : missionCycle,
            projectId : appid,
            id : id,
            name : name,
            taskGroupId : stepSeriesId,
            description : description,
            iconUrl : iconUrl,
            isLockedByLevel : lockBy,
            ...(lockByPSLevel?.length > 0 && {levelDetails : lockByPSLevel}),
            tags: eventTags,
            meta : finalMetaData,
            taskDetails : updatedTaskDetails,
            missionSequenceOrder : (missionOrder == false ? 'random' : 'sequence'),
            isLinkedRewardSameAsGeneralRewards : isLinkRewards,
        }
        console.log(mission, 'Mission')
        if(validation(mission)){
            try {
                if(visibleModal){
                    await dispatch(editStepSeriesAction(mission, navigate, appid, 'mission', globalStates.setShowOverlay, visibleModal, setVisibleModal))
                    setIsChanged(false)
                }else{
                    await dispatch(editStepSeriesAction(mission, navigate, appid, 'mission', globalStates.setShowOverlay))
                    setIsChanged(false)
                }
                // Access the response data (e.g., game ID) 
                setIsChanged(false);
                const user = JSON.parse(localStorage.getItem('user'))
                const memberID = user?.id
                const memberName = user?.name
                const orgId = (localStorage.getItem('orgId'))

                // Log activity in Firestore
                const activityLog = {
                    timestamp: new Date().toISOString(),
                    action_type: "UPDATE",
                    app_id:appid,
                    resource: "MISSION",
                    resource_id: id, // Use the ID from response
                    description: `Mission '${name}' updated successfully`,
                    quantity: 1,
...(localStorage.getItem('environment')&&{environment:localStorage.getItem('environment')}),
operation_status: "SUCCESS",
                    activity_feed: true,
                    priority: "LOW",
                    performed_by_id: memberID,
                    organization_id: orgId,
                    performed_by:memberName,
                    request_json:JSON.stringify(mission),
                };
                await addDoc(collection(db, "activityFeed"), activityLog);
await increaseUnreadCountForAllUsers( appid);
                console.log("Activity logged successfully");
            
                setIsChanged(false)
            } catch (error) {
                
            }
            
        
        }
    }

    const cancel = () => {
        navigate(`/mission/${appid}`)
        setIsChanged(false)
    }

    // Rewards

    const [allCurrency, setAllCurrency] = useState([])
    const [rewardCurrency, setRewardCurrency] = useState([])
    const [currencyPage, setCurrencyPage] = useState(1)
    const [currencyLimit, setCurrencyLimit] = useState(8)

    const getAllCurrencyData = () => {
        let getAllCurrency = {
            projectId : appid,
            offset: ((currencyPage-1)*currencyLimit),
            limit: currencyLimit
        }
        dispatch(getAllCurrencyAction(getAllCurrency))
    }

    useEffect(() => {
        getAllCurrencyData()
    }, [currencyPage])

    const customizeCurrencyData = () => {
        if(currenciesData && currenciesData.length > 0){
            setAllCurrency(currenciesData && currenciesData.map(value => ({...value, status : false, quantity : null})))
            const updatedArray = currenciesData && currenciesData.map((ele) => {
                const matchObj = content.find(element => element.currencyId == ele.id)
                if(matchObj){
                    return {
                        ...ele,
                        quantity : matchObj.quantity,
                        status : true
                    }
                }else{
                    return {
                        ...ele,
                        quantity : null,
                        status : false
                    }
                }
            })
            setRewardCurrency(updatedArray)
        }
    }

    let currenciesData = useSelector((state) => {
        return state.currencies.currency
    })

    useEffect(()=>{
        customizeCurrencyData()
    }, [currenciesData, called])

    const [allItems, setAllItems] = useState([])
    const [rewardItems, setRewardItems] = useState([])
    const [itemPage, setItemPage] = useState(1)
    const [itemLimit, setItemLimit] = useState(8)

    const getAllItemsData = () => {
        let items = {
            projectId : appid,
            offset: ((itemPage-1)*itemLimit),
            limit: itemLimit
        }
        dispatch(getAllItemAction(items))
    }

    let itemsData = useSelector((state) => {
        return state.item.items
    })

    useEffect(() => {
        getAllItemsData()
    }, [itemPage])

    const customizeItemData = () => {
        if(itemsData && itemsData.length > 0){
            setAllItems(itemsData && itemsData.map(value => ({...value, status : false, quantity : null})))
            const updatedArray = itemsData && itemsData.map(ele => {
                const matchObj = content.find(element => element.itemId == ele.id)
                if(matchObj){
                    return {
                        ...ele,
                        quantity : matchObj.quantity,
                        status : true
                    }
                }else{
                    return {
                        ...ele,
                        quantity : null,
                        status : false
                    }
                }
            })
            setRewardItems(updatedArray)
        }
    }

    useEffect(() => {
        customizeItemData()
    }, [itemsData, called])

    const [allBundle, setAllBundle] = useState([])
    const [rewardBundles, setRewardBundles] = useState([])
    const [bundlePage, setBundlePage] = useState(1)
    const [bundleLimit, setBundleLimit] = useState(8)

    const getAllBundlesData = () => {
        let bundles = {
            projectId : appid,
            offset: ((bundlePage-1)*bundleLimit),
            limit: bundleLimit
        }
        dispatch(getAllBundlesAction(bundles))
    }

    let bundleData = useSelector((state) => {
        return state.bundles.bundles
    })

    useEffect(() => {
        getAllBundlesData()
    }, [bundlePage])

    const customizeBundleData = () => {
        if(bundleData && bundleData.length > 0){
            setAllBundle(bundleData && bundleData.map(value => ({...value, status : false, quantity : null})))
            const updatedArray = bundleData && bundleData.map(ele => {
                const matchObj = content.find(element => element.bundleId == ele.id)
                if(matchObj){
                    return {
                        ...ele,
                        quantity : matchObj.quantity,
                        status : true
                    }
                }else{
                    return {
                        ...ele,
                        quantity : null,
                        status : false
                    }
                }
            })
            setRewardBundles(updatedArray)
        }
    }

    useEffect(() => {
        customizeBundleData()
    }, [bundleData, called])


    const [allPM, setAllPM] = useState([])
    const [rewardPM, setRewardPM] = useState([])
    const [pmPage, setPMPage] = useState(1)
    const [pmLimit, setPMLimit] = useState(8)

    const getAllPMData = () => {
        let progressionMarkers = {
            projectId : appid,
            ids : [],
            offset: ((pmPage-1)*pmLimit),
            limit: pmLimit
        }
        dispatch(getAllProgressionMarkerAction(progressionMarkers))
    }

    let pmData = useSelector((state)=>{
        return state.progressionMarkers.progressionMarker
    })

    useEffect(() => {
        getAllPMData()
    }, [pmPage])

    const customizePMData = () => {
        if(pmData && pmData.length > 0){
            setAllPM(pmData && pmData.map(value => ({...value, status : false, quantity : null})))
            const updatedArray = pmData && pmData.map(ele => {
                const matchObj = content.find(element => element.progressionMarkerId == ele.id)
                if(matchObj){
                    return {
                        ...ele,
                        quantity : matchObj.quantity,
                        status : true
                    }
                }else{
                    return {
                        ...ele,
                        quantity : null,
                        status : false
                    }
                }
            })
            setRewardPM(updatedArray)
        }
    }

    useEffect(() => {
        customizePMData()
    }, [pmData, called])
    
    const [content, setContent] = useState([])
    const [taskRewards, setTaskRewards] = useState([])
    const [stepSeries, setStepSeries] = useState([])
    const [isLink, setIsLink] = useState(false)
    const [isLinkRewards, setIsLinkRewards] = useState(false)
    const [linkRewards, setLinkRewards] = useState([])

    const storeTaskRewards = () => {
        sessionStorage.setItem('task-rewards', JSON.stringify(taskRewards))
    }
    
    const storeContent = () => {
        sessionStorage.setItem('contents', JSON.stringify(content))
    }

    const storeLinkReward = () => {
        sessionStorage.setItem('link-rewards', JSON.stringify(linkRewards))
    }

    const storeStepSeries = () => {
        sessionStorage.setItem('step-series', JSON.stringify(stepSeries))
    }
    
    useEffect(()=>{
    
    }, [content, taskRewards, stepSeries, linkRewards])

    
    useEffect(()=> {
        storeContent()
        storeStepSeries()
        storeTaskRewards()
        storeLinkReward()
    }, [])

    const [checkObject, setCheckObject] = useState()
    const [checkRewards, setCheckRewards] = useState([])
    const [checkTask, setCheckTask] = useState([])

    const convertRewards = async(data) => {
        let contentData = []
        return new Promise((resolve) => {
            data && data.forEach((e,i) =>{
                if((e.currencyId != undefined || e.currencyId != null)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, currencyId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.currencyId})
                    }
                }
                if((e.itemId != null || e.itemId != undefined)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, itemId : e.id, quantity : e.quantity, type : (e.isConsumable == true ? 'Consumable' : 'Durable'), archive : false, displayId : e.itemId})
                    }
                }
                if((e.bundleId != null || e.bundleId != undefined)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, bundleId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.bundleId})
                    }
                }
                if((e.progressionMarkerId != null || e.progressionMarkerId != undefined)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, progressionMarkerId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.progressionMarkerId})
                    }
                }
            })
            resolve(contentData)
        })
    }

    const getStepSeriesById = async() => {
        let getStepSeries = {
            projectId : appid,
            ids : [id],
            offset : 0,
            limit : 1,
            typeId : 1
        }
        const token = localStorage.getItem('token')
        const headers = {headers : {"Authorization" : `Bearer ${token}`, "Api-Key" : (localStorage.getItem('environment') == 'Production' ? JSON.parse(localStorage.getItem('apiKeys')).productionAPIKey : localStorage.getItem('environment') == 'Staging' ? JSON.parse(localStorage.getItem('apiKeys')).stagingAPIKey : JSON.parse(localStorage.getItem('apiKeys')).devAPIKey)}}
        let res = await customAxios.post(BASE_URL + GET_STEP_SERIES, getStepSeries, headers)
        let step = res.data.data.taskGroups[0]
        setCheckObject(step)
        // dispatch(getAllStepSeriesAction(getStepSeries))
        setLogo({src: (step.iconUrl != null ? step.iconUrl : Mission), alt: 'Upload an Image'})
        setIconUrl(step.iconUrl)
        setName(step.name)
        setType(step.type)
        setCyclePerMission(step.noOfMissionsPerCycle)
        setMissionCycle(step.shouldIncludeAllTasks !== null ? step.shouldIncludeAllTasks : true)
        setStepSeriesId(step.taskGroupId)
        setDescription(step.description)

        let updatedTasks = await Promise.all(step.taskDetails && step.taskDetails.map(async(item) => {
            let rewardsData = [...item.currencies, ...item.items, ...item.bundles, ...item.progressionMarkers]
            let linkRewardData = [...item.linkedRewardDetails.currencies, ...item.linkedRewardDetails.items, ...item.linkedRewardDetails.bundles, ...item.linkedRewardDetails.progressionMarkers]
            let currentTaskRewards = await convertRewards(rewardsData)
            let currentLinkedRewards = await convertRewards(linkRewardData)
            let removeKeys = ['currencies', 'items', 'bundles', 'progressionMarkers']
            removeKeys.forEach(key => delete item[key])
            return {
                ...item,
                rewardDetails: currentTaskRewards,
                linkedRewardDetails: currentLinkedRewards
            }
        }))
        setStepSeries(updatedTasks.sort((a,b)=>a.sortingOrder - b.sortingOrder))
        setCheckTask(updatedTasks.sort((a,b)=>a.sortingOrder - b.sortingOrder))
        sessionStorage.setItem('step-series', JSON.stringify(updatedTasks.sort((a,b)=>a.sortingOrder - b.sortingOrder)))

        let missionRewardsData = [...step.currencies,...step.items, ...step.bundles, ...step.progressionMarkers]
        let updatedmissionRewards = await convertRewards(missionRewardsData)
        setContent(updatedmissionRewards)
        sessionStorage.setItem('contents', JSON.stringify(updatedmissionRewards))

        let linkRewardData = step.linkedRewardDetails
        let totalLinkRewards = [...linkRewardData.items, ...linkRewardData.bundles, ...linkRewardData.currencies, ...linkRewardData.progressionMarkers]
        if(totalLinkRewards?.length > 0){
            setIsLink(true)
        }
        setIsLinkRewards(step.isLinkedRewardSameAsGeneralRewards)
        let updatedLinkRewards = await convertRewards(totalLinkRewards)
        setLinkRewards(updatedLinkRewards)
        setCheckRewards(updatedLinkRewards)
        sessionStorage.setItem('link-rewards', JSON.stringify(updatedLinkRewards))

        step.tagsMapping && step.tagsMapping.forEach(e => {
            e.tag && setTags(tags => [...tags, {id : e.tag.id, text : e.tag.name}])
        });
        // const updatedData = step.taskDetails && step.taskDetails.map((item) => {
        //     let rewardsData = [...item.currencies, ...item.items, ...item.bundles, ...item.progressionMarkers]
        //     let taskLinkData = []
        //     let contentData = []
        //     rewardsData && rewardsData.forEach((e,i) =>{
        //         if((e.currencyId != undefined || e.currencyId != null)){
        //             if(e.archive == false){
        //                 contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, currencyId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.currencyId})
        //             }
        //         }
        //         if((e.itemId != null || e.itemId != undefined)){
        //             if(e.archive == false){
        //                 contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, itemId : e.id, quantity : e.quantity, type : (e.isConsumable == true ? 'Consumable' : 'Durable'), archive : false, displayId : e.itemId})
        //             }
        //         }
        //         if((e.bundleId != null || e.bundleId != undefined)){
        //             if(e.archive == false){
        //                 contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, bundleId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.bundleId})
        //             }
        //         }
        //         if((e.progressionMarkerId != null || e.progressionMarkerId != undefined)){
        //             if(e.archive == false){
        //                 contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, progressionMarkerId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.progressionMarkerId})
        //             }
        //         }
        //     })
        //     delete item.currencies
        //     delete item.items
        //     delete item.bundles
        //     delete item.progressionMarkers
        //     return {
        //         ...item,
        //         rewardDetails: contentData,
        //     };
        // });
        // setStepSeries(updatedData.sort((a,b)=>a.sortingOrder - b.sortingOrder))
        // sessionStorage.setItem('step-series', JSON.stringify(updatedData.sort((a,b)=>a.sortingOrder - b.sortingOrder)))
        
        // let rewardsData = [...step.currencies,...step.items, ...step.bundles, ...step.progressionMarkers]
        // let contentData = []
        // rewardsData && rewardsData.forEach((e,i) =>{
        //     if((e.currencyId != undefined || e.currencyId != null)){
        //         if(e.archive == false){
        //             contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, currencyId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.currencyId})
        //         }
        //     }
        //     if((e.itemId != null || e.itemId != undefined)){
        //         if(e.archive == false){
        //             contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, itemId : e.id, quantity : e.quantity, type : (e.isConsumable == true ? 'Consumable' : 'Durable'), archive : false, displayId : e.itemId})
        //         }
        //     }
        //     if((e.bundleId != null || e.bundleId != undefined)){
        //         if(e.archive == false){
        //             contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, bundleId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.bundleId})
        //         }
        //     }
        //     if((e.progressionMarkerId != null || e.progressionMarkerId != undefined)){
        //         if(e.archive == false){
        //             contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, progressionMarkerId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.progressionMarkerId})
        //         }
        //     }
        // })
        // setContent(contentData)
        // sessionStorage.setItem('contents', JSON.stringify(contentData))
        
        // let totalLinkRewards = []
        // let linkRewardData = step.linkedRewardDetails   

        // let updatedLinkReward = [...linkRewardData.items, ...linkRewardData.bundles, ...linkRewardData.currencies, ...linkRewardData.progressionMarkers]
        // if(updatedLinkReward?.length > 0){
        //     setIsLink(true)
        //     setIsLinkRewards(true)
        // }
        // updatedLinkReward && updatedLinkReward.forEach((e,i) =>{
        //     if((e.currencyId != undefined || e.currencyId != null)){
        //         if(e.archive == false){
        //             totalLinkRewards.push({id: e.id, iconUrl : e.iconUrl, name : e.name, currencyId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.currencyId})
        //         }
        //     }
        //     if((e.itemId != null || e.itemId != undefined)){
        //         if(e.archive == false){
        //             totalLinkRewards.push({id: e.id, iconUrl : e.iconUrl, name : e.name, itemId : e.id, quantity : e.quantity, type : (e.isConsumable == true ? 'Consumable' : 'Durable'), archive : false, displayId : e.itemId})
        //         }
        //     }
        //     if((e.bundleId != null || e.bundleId != undefined)){
        //         if(e.archive == false){
        //             totalLinkRewards.push({id: e.id, iconUrl : e.iconUrl, name : e.name, bundleId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.bundleId})
        //         }
        //     }
        //     if((e.progressionMarkerId != null || e.progressionMarkerId != undefined)){
        //         if(e.archive == false){
        //             totalLinkRewards.push({id: e.id, iconUrl : e.iconUrl, name : e.name, progressionMarkerId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.progressionMarkerId})
        //         }
        //     }
        // })
        // setLinkRewards(totalLinkRewards)
        // setCheckRewards(totalLinkRewards)
        // sessionStorage.setItem('link-rewards', JSON.stringify(totalLinkRewards))

        setMissionReward(step.rewardClaim == 'automatic' ? false : true)
        setClaim(step.rewardClaim == 'automatic' ? false : true)
        setMissionOrder((step.missionSequenceOrder && step.missionSequenceOrder != null && step.missionSequenceOrder == 'random') ? false : (step.missionSequenceOrder && step.missionSequenceOrder != null && step.missionSequenceOrder == 'sequence') ? true  : false)
        if(step.levelDetails && step.levelDetails.length > 0){
            setLockBy(true)
            step.levelDetails && step.levelDetails.forEach((ele, i) => {
                if(ele.id){
                    if (!ele.archive) {
                        setPS(prevState => [...prevState, {dbID : ele.id ,id : ele.levelSystemId, name : ele.levelSystemName, lockedLevel: ele.levelNo, archive:ele.archive}])
                    }
                    else{
                        setPS(prevState => [...prevState, {dbID : ele.id ,id : ele.levelSystemId, name : ele.levelSystemName, lockedLevel: null, archive:ele.archive}])
                    }
                }
            })
        }else{
            setLockBy(false)
        }
        let meta = []
        if(step.meta == null || JSON.stringify(step.meta) == '{}'){
            setMetaData([{key : '', value : ''}])
        }else{
            step.meta && Object.keys(step.meta).forEach(e => {
            meta.push({key : e, value : step.meta[e]})
        });
            setMetaData(meta)
        }
        setCalled(true)
    }

    useEffect(() => {
        getStepSeriesById()
    }, [])
  
    const [visibleHelp, setVisibleHelp] = useState(false)

    const [media, setMedia] = useState([])

    const getMedia = async() => {
        let getMediaData = {
            projectId : appid,
            category: 'icons',
            typeId : 0
        }
        await dispatch(getAllMediaAction(getMediaData))
    }

    let files = useSelector((state) => {
        return state.media.media.mediaDetails
    })

    const configureMedia = () => {
        if(files && files.length > 0){
            setMedia(files && files.map((e, i) => ({...e, status : false})))
        }else{
            setMedia([])
        }
    }

    useEffect(() => {
        getMedia()
    }, [])

    useEffect(() => {
        configureMedia()
    }, [files])

    function compareUnlockConditionsArrays(arr1, arr2) {
        //  
        let array1=arr1&& arr1.filter(item => !item?.archive)
        let array2=arr2&& arr2.filter(item => !item?.archive)
        if (array1?.length !== array2?.length) {
            return false
        }
        for (let i = 0; i < array1.length; i++) {
            if (
                (parseInt(array1[i]?.lockedLevel)===array2[i]?.lockedLevel|| array2[i]?.lockedLevel==undefined|| array2[i]?.lockedLevel==null)&&
                (array1[i]?.unlockLevelSystemId===array2[i]?.unlockLevelSystemId || array2[i]?.unlockLevelSystemId==undefined|| array2[i]?.unlockLevelSystemId==null)
            ) {
            }
            else{
                return false;
            }
        }

        return true;
    }

    function compareContentArrays(arr1, arr2) {
         
        let array1=arr1&& arr1.filter(item => !item?.archive)
        let array2=arr2&& arr2.filter(item => !item?.archive)
        if (array1?.length !== array2?.length) {
            return false;
        }
    
        // Iterate over the arrays
        for (let i = 0; i < array1.length; i++) {
            if (
                (array1[i]?.displayId==array2[i]?.displayId || array2[i]?.displayId==undefined|| array2[i]?.displayId==null)&&
                parseInt(array1[i].quantity)===array2[i].quantity
            ) {
            }
            else{
                return false;
            }
        }

        return true;
    }
    function compareTaskArrays(arr1, arr2) {
         
        let array1=arr1&& arr1.filter(item => !item?.archive)
        let array2=arr2&& arr2.filter(item => !item?.archive)
        if (array1?.length !== array2?.length) {
            return false;
        }
        // Iterate over the arrays
        for (let i = 0; i < array1.length; i++) {
            let configg1
            let businessLogicc1
            let configg2
            let businessLogicc2
            configg1=array1[i]?.config
            if(array1[i].businessLogic != undefined && array1[i].businessLogic != null && array1[i].businessLogic.all != undefined && array1[i].businessLogic.any == undefined){
                businessLogicc1=array1[i].businessLogic.all
            }else if(array1[i].businessLogic != undefined && array1[i].businessLogic != null && array1[i].businessLogic.all == undefined && array1[i].businessLogic.any != undefined){
                businessLogicc1=array1[i].businessLogic.any
            }
            configg2=array2[i]?.config
            if(array2[i].businessLogic != undefined && array2[i].businessLogic != null && array2[i].businessLogic.all != undefined && array2[i].businessLogic.any == undefined){
                businessLogicc2=array2[i].businessLogic.all
            }else if(array2[i].businessLogic != undefined && array2[i].businessLogic != null && array2[i].businessLogic.all == undefined && array2[i].businessLogic.any != undefined){
                businessLogicc2=array2[i].businessLogic.any
            }
            let cnfgCheck=checkObject&& compareQueryConfigArrays(configg1, configg2)
            let bsnsCheck=checkObject && compareQueryBusinessLogicArrays(businessLogicc1, businessLogicc2)
            
            if (
                (array1[i]?.id==array2[i]?.id)&&
                (cnfgCheck)&&
                (bsnsCheck)&&
                (array1[i].defaultEventId==array2[i].defaultEventId)&&
                (array1[i].customEventId==array2[i].customEventId)&&
                (array1[i].iconUrl==array2[i].iconUrl)&&
                (array1[i].description==array2[i].description)&&
                (array1[i].name==array2[i].name)&&
                (array1[i].rewardClaim==array2[i].rewardClaim)&&
                (array1[i].taskId==array2[i].taskId)&&
                (array1[i].type==array2[i].type)
            ) {
            }
            else{
                return false;
            }
        }

        return true;
    }
    function compareQueryConfigArrays(arr1, arr2) {
         
        let array1=arr1&& arr1.filter(item => !item?.archive)
        let array2=arr2&& arr2.filter(item => !item?.archive)
        if((array1==null||array1==undefined)&&(array2==null||array2==undefined)){
            return true
        }
        else if((array1==null||array1==undefined)||(array2==null||array2==undefined)){
            return false
        }
        if (array1?.length !== array2?.length) {
            return false;
        }
    
        // Iterate over the arrays
        for (let i = 0; i < array1.length; i++) {
            if (
                (array1[i]?.dataType==array2[i]?.dataType)&&
                (array1[i]?.incrementalType==array2[i]?.incrementalType)&&
                (array1[i]?.operator==array2[i]?.operator)&&
                (array1[i]?.parameterId==array2[i]?.parameterId)&&
                (array1[i]?.parameterName==array2[i]?.parameterName)&&
                (parseInt(array1[i]?.noOfRecords)==parseInt(array2[i]?.noOfRecords)||(array2[i]?.noOfRecords==null && array1[i]?.noOfRecords==null))&&
                (array1[i]?.type==array2[i]?.type)&&
                (parseInt(array1[i]?.value)==parseInt(array2[i]?.value))
            ) {
            }
            else{
                return false;
            }
        }

        return true;
    }
    function compareQueryBusinessLogicArrays(arr1, arr2) {
         
        let array1=arr1&& arr1.filter(item => !item?.archive)
        let array2=arr2&& arr2.filter(item => !item?.archive)
        if((array1==null||array1==undefined)&&(array2==null||array2==undefined)){
            return true
        }
        else if((array1==null||array1==undefined)||(array2==null||array2==undefined)){
            return false
        }
        if (array1?.length !== array2?.length) {
            return false;
        }
    
        // Iterate over the arrays
        for (let i = 0; i < array1.length; i++) {
            if (array1[i]?.all) {
                if (array1[i]?.all) {
                    for (let n = 0; n < array1[i]?.all.length; n++) {
                        let all1 = array1[i]?.all[n];
                        let all2 = array2[i]?.all[n];
                        if (
                            (all1?.fact==all2?.fact)&&
                            (all1?.operator==all2?.operator)&&
                            (parseInt(all1?.value)==parseInt(all2?.value))
                        ) {
                            
                        } else {
                            return false;
                        }
                    }
                }
                else {
                    return false;
                }
                
            } else if (array1[i]?.any) {
                if (array2[i]?.any) {
                    for (let m = 0; m < array1[i]?.any.length; m++) {
                        const any1 = array1[i]?.any[m];
                        const any2 = array1[i]?.any[m];
                            if (
                            (any1?.fact==any2?.fact)&&
                            (any1?.operator==any2?.operator)&&
                            (parseInt(any1?.value)==parseInt(any2?.value))
                        ) {
                            
                        } else {
                            return false;
                        }
                    }
                }
                else {
                    return false;
                }

                
            }
            else {
                if (
                    (array1[i]?.fact==array2[i]?.fact)&&
                    (array1[i]?.operator==array2[i]?.operator)&&
                    (parseInt(array1[i]?.value)==parseInt(array2[i]?.value))
                ) {
                    
                } else {
                    return false;
                }

            }
        }

        return true;
    }


    const setchange = () => {
                
        let metaDataList = [...metaData];
        let finalMetaData = {};
        for(var i = 0; i < metaDataList.length ; i++){
            finalMetaData[metaDataList[i].key] = metaDataList[i].value;
        }

        let itemTags = []
        tags && tags.forEach((e)=>{
            itemTags.push(e.text)
        })

        let checkTags = []
        checkObject?.tagsMapping && checkObject?.tagsMapping.forEach((e)=>{
            if (e.tag!==null&&e.tag!==undefined) {
            checkTags.push(e?.tag?.name)
            }
        })
        let unlockPS = []
        PS && PS.map((e,i) =>{
            unlockPS.push({id: e.dbID, unlockItemId : null, unlockLevelSystemId : e.id, lockedLevel : e.lockedLevel})
        })
        let ps=[]
        let lkBy 
        if(checkObject?.levelDetails && checkObject.levelDetails.length > 0){
            lkBy=true
            checkObject.levelDetails && checkObject.levelDetails.forEach((ele, i) => {
                if(ele.id){
                    ps.push({id : ele.id , id : ele.levelSystemId, name : ele.levelSystemName, lockedLevel: ele.levelNo})
                }
            })
        }else{
            lkBy=false
        }
        let contentCheck
        let taskCheck
        if (checkObject) {
            let RewardsData = [...checkObject?.currencies,...checkObject?.items, ...checkObject?.bundles, ...checkObject?.progressionMarkers]
            let contentData = []
   
            RewardsData && RewardsData.forEach((e,i) =>{
                if((e.currencyId != undefined || e.currencyId != null)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, currencyId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.currencyId})
                    }
                }
                if((e.itemId != null || e.itemId != undefined)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, itemId : e.id, quantity : e.quantity, type : (e.isConsumable == true ? 'Consumable' : 'Durable'), archive : false, displayId : e.itemId})
                    }
                }
                if((e.bundleId != null || e.bundleId != undefined)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, bundleId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.bundleId})
                    }
                }
                if((e.progressionMarkerId != null || e.progressionMarkerId != undefined)){
                    if(e.archive == false){
                        contentData.push({id: e.id, iconUrl : e.iconUrl, name : e.name, progressionMarkerId : e.id, quantity : e.quantity, type : null, archive : false, displayId : e.progressionMarkerId})
                    }
                }
            })
            contentCheck = checkObject && compareContentArrays(content, contentData)       
            taskCheck = checkObject && compareTaskArrays(stepSeries, checkObject?.taskDetails)
        }
        let psCheck=checkObject && ((checkObject.levelDetails&& compareUnlockConditionsArrays(unlockPS, ps))||!ps)
        if (checkObject&&
            (iconUrl==checkObject.iconUrl)&&
            (name==checkObject.name)&&
            (stepSeriesId==checkObject.taskGroupId)&&
            (description==checkObject.description||(checkObject.description==null&&description==''))&&
            (type==checkObject.type)&&
            (cyclePerMission==checkObject.noOfMissionsPerCycle||(checkObject.noOfMissionsPerCycle==null&&cyclePerMission==''))&&
            (missionReward==(checkObject.rewardClaim == 'automatic' ? false : true))&&
            (lockBy==((checkObject.levelDetails && checkObject.levelDetails.length > 0)?true:false))&&
            (taskRewards.length==0)&&
            (psCheck)&&
            (contentCheck)&&
            // (taskCheck)&&
            ((JSON.stringify(finalMetaData) == JSON.stringify(checkObject.meta))||((JSON.stringify(finalMetaData)=='{"":""}')&&(checkObject.meta==null)))&&
            (JSON.stringify(itemTags) == JSON.stringify(checkTags)|| (checkObject?.tagsMapping==null && itemTags.length==0))
        )
        {
            setIsChanged(false)
        }
        else 
        {
            setIsChanged(true)
        }
    }
    // const [query, setQuery] = useState({combinator : 'and', rules : [{field : '', value : {value : null, type : false, allTime : true, noOfRecords : null}, operator : ''}]})
    useEffect(()=>{
        setchange()
    },[iconUrl,name,stepSeriesId,description,type,typeId,missionReward,PS,lockBy,cyclePerMission,content,taskRewards,stepSeries,tags,metaData])

    const [missionOrderOption, setMissionOrderOption] = useState([{id: 1, name: 'Random'}, {id: 2, name: 'Sorting Order'}])
    const [missionOrder, setMissionOrder] = useState(false)
    const [missionCycle, setMissionCycle] = useState(true)

    // Link Rewards

    const onChangeLink = (e) => {
        if(e.target.checked){
            setIsLink(true)
            setLinkRewards(content)
            sessionStorage.setItem('link-rewards',  JSON.stringify(content))
        }else{
            let rewards = JSON.parse(sessionStorage.getItem('link-rewards'))
            let allRewards = [...content, ...rewards.map(e => ({...e, archive: true}))]
            setIsLink(false)
            setIsLinkRewards(false)
            setLinkRewards(allRewards)
            sessionStorage.setItem('link-rewards',  JSON.stringify(allRewards))
        }
    }

    const onChangeLinkRewards = (e) => {
        if(isLinkRewards){
            let rewards = JSON.parse(sessionStorage.getItem('link-rewards'))
            let allRewards = [...content, ...rewards.map(e => ({...e, archive: true}))]
            setIsLinkRewards(false)
            setLinkRewards(allRewards)
            sessionStorage.setItem('link-rewards',  JSON.stringify(allRewards))
        }else{
            setIsLinkRewards(true)
            setLinkRewards(checkRewards)
            sessionStorage.setItem('link-rewards',  JSON.stringify(checkRewards))
        }
    }

    const configureRewards = () => {
        if(isLink){
            if(!isLinkRewards){
                setLinkRewards(content)
                sessionStorage.setItem('link-rewards',  JSON.stringify(content))
            }
        }else{
            setLinkRewards([])
            sessionStorage.setItem('link-rewards',  JSON.stringify([]))
        }
    }

    useEffect(() => {
        configureRewards()
    }, [content])

    return(
        <>
            <Card className={cn(styles.card, className)} title="Information" classTitle="title-purple">
                <div className={styles.cardDescription}>
                    <div className={styles.preview}>   
                        <div className={styles.previewImage}>
                            <img src={src} alt={alt} style={{maxWidth: "100px", maxHeight: "100px"}}></img>
                        </div>
                        <div className={styles.previewInput}> 
                            <input type="file" className='file-input' accept="image/jpeg, image/png, image/webp, .jpeg, .jpg, .png, .webp" ref={ref} onChange={(e)=>{uploadLogo(e)}}/>
                            <label className={styles.button} onClick={() => setVisibleHelp(true)}><AddButtonIcon className={styles.addIcon}/>Upload Icon</label>
                        </div>
                        {iconUrl != null && 
                            <div className={styles.previewCancel}>
                                <button className={styles.buttonCancel} onClick={Cancel}>Remove</button>
                            </div>
                        }
                    </div>
                    <FileUploadSidebar media={media} setMedia={setMedia} types='Images' id={`icon`} multiple={false} visible={visibleHelp} setVisible={setVisibleHelp} icon={iconUrl} setIcon={setIconUrl} setValue={setLogo} onClose={onClose} />
                    <div className={styles.infoGroup}>
                        <div className={styles.group}>
                            <TextInput tooltip={TooltipTitle.MissionName} id='missionName' className={styles.field} errorMessage={errors.nameError} label="Display Name*" name="displayName" type="text" required value={name} onChange={(e)=>{onChangeName(e)}} />
                            <TextInput isId={true} tooltip={TooltipTitle.MissionId} id='missionId' className={styles.field} errorMessage={errors.idError} label="Mission ID*" name="itemId" type="text" required value={stepSeriesId} onChange={(e)=>{onChangeId(e)}} />
                        </div>

                        <div className={styles.textArea}>
                            <TextArea type='MISSIONS_DESCRIPTION' tooltip={TooltipTitle.MissionDescription} className={styles.field} rows={5} label="Mission Description" value={description} onChange={(e)=>{onChangeDescription(e)}} />
                        </div>
                    </div>
                </div>
            </Card>

            <Card className={cn(styles.card, className)} title="Configure" classTitle="title-red">
                <div className={styles.cardDescription}>
                    <div className={styles.infoGroup}>
                        <div className={styles.group}>
                            <div className={styles.fieldRadio}>
                                <div className={styles.radioLabel}>
                                    <span>Missions per Cycle<span><Tooltips className={styles.tooltip} title={TooltipTitle.MissionReward} icon="info"/></span></span>
                                </div>
                                <div className={styles.variants}>
                                    <Radio className={styles.radioConfig} name="missonPerCycle" content="All" value={missionCycle} onChange={() => {setMissionCycle(true);setCyclePerMission(null)}}/>
                                    <Radio className={styles.radioConfig} name="missonPerCycle" content="Specify No of Missions per Cycle" value={!missionCycle} onChange={() => {setMissionCycle(false);setCyclePerMission(null)}}/>
                                </div>
                            </div>
                            {!missionCycle && <TextInput tooltip={TooltipTitle.MissionCycle} className={styles.field} label="Specify No of Missions per Cycle" name="cycles" type="text" required value={cyclePerMission} onChange={(e)=>{onCycleperMission(e)}} />}
                        </div>
                    </div>
                    <div className={styles.infoGroup}>
                        <div className={styles.group}>
                            <div className={styles.fieldRadio}>
                                <div className={styles.radioLabel}>
                                    <span>Grant Reward<span><Tooltips className={styles.tooltip} title={TooltipTitle.MissionGrant} icon="info"/></span></span>
                                </div>
                                <div className={styles.variants}>
                                    <Radio disabled={true} className={styles.radioConfig} name="missionReward" content="Server Side" value={!missionReward} onChange={()=>{setMissionReward(false)}}/>
                                    <Radio className={styles.radioConfig} name="missionReward" content="Client Side" value={missionReward} onChange={()=>{setMissionReward(true)}}/>
                                </div>
                            </div>
                            <div className={styles.fieldRadio}>
                                <div className={styles.radioLabel}>
                                    <span>Mission Order<span><Tooltips className={styles.tooltip} title={TooltipTitle.MissionGrant} icon="info"/></span></span>
                                </div>
                                <div className={styles.variants}>
                                    <Radio className={styles.radioConfig} name="missionOrder" content="Random" value={!missionOrder} onChange={()=>{setMissionOrder(false)}}/>
                                    <Radio className={styles.radioConfig} name="missionOrder" content="Sorting Order" value={missionOrder} onChange={()=>{setMissionOrder(true)}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>

        
            <Card className={cn(styles.card, className)} title="Task" classTitle="title-green"
                head={
                    <div className={styles.accessEligibility}>
                        <div className={styles.groupHeading}>
                            <Control taskType={type} modalFor='Mission' type='Task' width='medium' currency={allCurrency} setCurrency={setAllCurrency} currencyCount={currencyLimit} currencyPage={setCurrencyPage} item={allItems} setItem={setAllItems} itemCount={itemLimit} itemPage={setItemPage} bundle={allBundle} setBundle={setAllBundle} bundleCount={bundleLimit} bundlePage={setBundlePage} PM={allPM} setPM={setAllPM} PMCount={pmLimit} PMPage={setPMPage} setValue={setTaskRewards} setStepSeries={setStepSeries}/>
                        </div>
                    </div>
                }
            >
                {stepSeries && stepSeries.length > 0 &&
                    <div className={styles.cardDescription}>
                        <div className={styles.accessEligibility}>
                            <StepSeriesTableLayout modalFor='Mission' as='edit' order={missionOrder} usedFor='Mission' currency={allCurrency} setCurrency={setAllCurrency} currencyCount={currencyLimit} currencyPage={setCurrencyPage} item={allItems} setItem={setAllItems} itemCount={itemLimit} itemPage={setItemPage} bundle={allBundle} setBundle={setAllBundle} bundleCount={bundleLimit} bundlePage={setBundlePage} PM={allPM} setPM={setAllPM} PMCount={pmLimit} PMPage={setPMPage} setValue={setTaskRewards} items={stepSeries} setStepSeries={setStepSeries} type='list' />
                        </div>
                    </div>
                }
            </Card>

            <Card className={cn(styles.card, className)} title="Rewards" classTitle="title-green"
                head={
                    <div className={styles.accessEligibility}>
                        <div className={styles.groupHeading}>
                            <ControlRewards pageItem={itemPage} pageCurrnecy={currencyPage} pageBundle={bundlePage} pagePM={pmPage} type='Task' width='medium' currency={rewardCurrency} setCurrency={setRewardCurrency} currencyCount={currencyLimit} currencyPage={setCurrencyPage} item={rewardItems} setItem={setRewardItems} itemCount={itemLimit} itemPage={setItemPage} bundles={rewardBundles} setBundle={setRewardBundles} bundleCount={bundleLimit} bundlePage={setBundlePage} PM={rewardPM} setPM={setRewardPM} PMCount={pmLimit} PMPage={setPMPage} value={content} setValue={setContent} setCalled={setCalled} />
                        </div>
                    </div>
                }
            >
                {content && content.length > 0 &&
                    <div className={styles.cardDescription}>
                        <>
                            <div className={styles.accessEligibility}>
                                <div className={styles.content}>
                                    <div className={styles.wrapper}>
                                        <ContentTable items={content} setValue={setContent} allCurrency={rewardCurrency} setAllCurrency={setRewardCurrency} allItems={rewardItems} setAllItems={setRewardItems} allBundles={rewardBundles} setAllBundle={setRewardBundles} allPM={rewardPM} setAllPM={setRewardPM}/>
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                }
            </Card>

            <Card className={cn(styles.card, className)} title="Link Rewards" classTitle="title-green"
                head={
                    <>
                        <div className={styles.selection}>
                            <Switch value={isLink} onChange={(e) => {onChangeLink(e)}}/>
                        </div>
                    </>
                }>
                {isLink &&
                <div className={styles.cardDescription}>
                        <div className={styles.accessEligibility}>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label="Link Reward Type" name="linkeward" type="text" required disabled value='User Referral' />
                                <div className={styles.fieldRadio}>
                                    <div className={styles.radioLabel}>
                                        <span>Is link rewards same as task rewards?</span>
                                    </div>
                                    <div className={styles.variants}>
                                        <Radio className={styles.radioConfig} value={!isLinkRewards} name="isLinkRewards" onChange={(e) => {onChangeLinkRewards(e)}} content="Yes" />
                                        <Radio className={styles.radioConfig} value={isLinkRewards} name="isLinkRewards" onChange={(e) => {onChangeLinkRewards(e)}} content="No" />
                                    </div>
                                </div>
                            </div>
                            {isLinkRewards &&
                                <ControlRewards usedFor='Link Rewards' type='Task' pageItem={itemPage} pageCurrnecy={currencyPage} pageBundle={bundlePage} pagePM={pmPage} currency={rewardCurrency} setCurrency={setRewardCurrency} currencyCount={currencyLimit} currencyPage={setCurrencyPage} item={rewardItems} setItem={setRewardItems} itemCount={itemLimit} itemPage={setItemPage} bundles={rewardBundles} setBundle={setRewardBundles} bundleCount={bundleLimit} bundlePage={setBundlePage} PM={rewardPM} setPM={setRewardPM} PMCount={pmLimit} PMPage={setPMPage} value={linkRewards} setValue={setLinkRewards} setCalled={setCalled} width='medium'/>
                            } 
                        </div> 
                        {linkRewards && linkRewards?.length > 0 &&
                            <div className={styles.accessEligibility}>
                                <div className={styles.content}>
                                    <div className={styles.wrapper}>
                                        <ContentTable usedFor='Link Rewards' disable={!isLinkRewards} items={linkRewards} setValue={setLinkRewards} allCurrency={rewardCurrency} setAllCurrency={setRewardCurrency} allItems={rewardItems} setAllItems={setRewardItems} allBundles={rewardBundles} setAllBundle={setRewardBundles} allPM={rewardPM} setAllPM={setRewardPM}/>
                                    </div>
                                </div>
                            </div> 
                        }
                </div>
                }
            </Card>

            <Card className={cn(styles.card, className)} title="Access & Eligibility" classTitle="title-blue">
                <div className={styles.cardDescription}>
                    <div className={styles.accessEligibility}>
                        <div className={styles.group}>
                            <div className={styles.fieldRadio}>
                                <div className={styles.radioLabel}>
                                    <span>Lock by Level<span><Tooltips className={styles.tooltip} title={TooltipTitle.MissionLock} icon="info"/></span></span>
                                </div>
                                <div className={styles.variants}>
                                    <Radio className={styles.radio} value={lockBy} name="lockBy" onChange={() => setLockBy(true)} content="Yes" />
                                    <Radio className={styles.radio} value={!lockBy} name="lockBy" onChange={() => setLockBy(false)} content="No" />
                                </div>
                            </div>
                            {lockBy &&
                                <div className={styles.field}>
                                    <div className={styles.lockGroup}>
                                        <div className={styles.radioLabel}>
                                            <span>Choose Progression System<span><Tooltips className={styles.tooltip} title={TooltipTitle.MissionPS} icon="info"/></span></span>
                                        </div>
                                        <CommonDropdown placeholder='Select Progression System' className={styles.selectField} options={PSOptions} value={PS} setValue={setPS} error={setLockPSErr}/>
                                        {lockPSErr && <span className={styles.danger}>*Progression System is required.</span>}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    
                    {lockBy &&
                        <div className={styles.accessEligibility}>
                            <div className={styles.group}>
                                {PS && PS.map((element, index) =>{
                                    return(!element.archive &&
                                        <>
                                            <div style={{marginTop:"8px"}} className={styles.field}>
                                            <ProgressionLevelMultiSelect placeholder='Select Level' label={element.name} options={(PSOptions.find(x=>x.name==element.name)?.levelSystemLevelMapping)&&(PSOptions.find(x=>x.name==element.name)?.levelSystemLevelMapping)} ind={index} value={PS} setValue={setPS}/>
                                            </div>
                                            {/* <TextInput tooltip={TooltipTitle.MissionPSLevel} value={element.lockedLevel} className={styles.field} label={`${element.name}`} currency='Level' style='grey' type="number" onWheelCapture={e => {e.currentTarget.blur()}} required onChange={(e) => {onChangeLevel(e.target.value, index)}}/> */}
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    }
                </div>
            </Card>


            <Card className={cn(styles.card, className)} title="Custom Data" classTitle="title-red">
                <div className={styles.cardDescription}>
                    <div className={styles.customData}>  
                    <TagInputWithDropdown tooltip={TooltipTitle.MissionTags} tags={tags} setTags={setTags}/>
                        <div className={styles.groupHeading}>
                            <span>Meta Data<span><Tooltips className={styles.tooltip} title={TooltipTitle.MissionMetaData} icon="info"/></span></span><span className={styles.addIcon} onClick={addMetaData}><AddMetaIcon /></span>
                        </div>

                        {metaData && metaData.length > 0 &&
                            <div className={styles.groupMeta}>
                                <div className={styles.field}>Key</div>
                                <div className={styles.field}>Value</div>
                            </div>
                        }

                        <div className={styles.groupMeta}>
                            {metaData && metaData.map((e,i)=>{
                                return(
                                    <>
                                        <TextInput className={styles.field} label="" name="key" type="text" required value={(metaData[i].key != '' || metaData[i].key != undefined || metaData[i].key != null) ? metaData[i].key : ''} onChange={(e)=>{onChangeKey(e, i)}}/>
                                        <JSONMetaDataValueInput key={i} className={styles.field} data={(typeof e.value == 'string') ? JSON.stringify(e.value) : e.value} value={metaData} setValue={setMetaData} index={i}/>
                                        {/* <TextInput className={styles.field} label="" name="value" type="text" required  value={(metaData[i].value != '' || metaData[i].value != undefined || metaData[i].value != null) ? metaData[i].value : ''} onChange={(e)=>{onChangeValue(e, i)}}/> */}
                                        <span className={styles.remove} onClick={()=>{removeMetaData(i)}}><RemoveIcon className={styles.icon} /></span>
                                    </>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </Card>

            <Card className={cn(styles.card, className)}>
                <div className={styles.cardAction}>
                    <div className={styles.cardSave}>
                        <button className={cn(styles.button, 'button-save-small')} onClick={submit}>Save</button>
                    </div>
                    <div className={styles.cardSave}>
                        {checkObject && <Schedule liveOpsStatus={checkObject.status} id={id} as={`saveNschedule`} type='Mission' saveTaskGroup={submit} name={name}/>}
                    </div>
                    <div className={styles.cardCancel}>
                        <button className={cn(styles.button, 'button-cancel-small')} onClick={cancel}>Cancel</button>
                    </div>
                </div>
            </Card>
        </>
    )

}

export default StepSeriesInfo